import { createContext } from 'react';

import { OrganizationReport } from '@totem/components/cyberReview/dataTypes';
import { ReportInput } from '@totem/components/cyberReview/parameterTypes';

interface Context {
  input: ReportInput;
  setInput: (input: ReportInput) => void;
  onAction?: (action: string) => void;
  loading: boolean;
  reportData: OrganizationReport;
  totalRecords: number;
}

export default createContext<Context>({
  input: {},
  setInput: () => {},
  onAction: () => {},
  loading: false,
  reportData: null,
  totalRecords: 0,
});
